import { render, staticRenderFns } from "./ClientGate.vue?vue&type=template&id=cb6ffbca"
import script from "./ClientGate.vue?vue&type=script&lang=js"
export * from "./ClientGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports